//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import { createSlice } from '@reduxjs/toolkit';

import { CustomActionState } from './types';

export const initialState: CustomActionState = {
  customActionWizardVisible: false,
  customActionSharing: {
    visible: false,
  },
  customActionBeingEdited: null,
};

const customActionSlice = createSlice({
  name: 'customAction',
  initialState,
  reducers: {
    showCustomActionWizard: (state, action) => {
      state.customActionWizardVisible = action.payload.visible;
      state.wizardInitialMethod = action.payload.visible ? action.payload.initialMethod : undefined;
    },
    showCustomActionShare: (state, action) => {
      state.customActionSharing = {
        visible: action.payload.visible,
        customActionId: action.payload.customActionId,
      };
    },
    setCustomActionBeingEdited: (state, action) => {
      state.customActionBeingEdited = action.payload;
    },
  },
  extraReducers: {
    SAVE_CUSTOM_ACTION_SUCCESS: (state, action) => {},
  },
});

export const {
  reducer,
  actions: { showCustomActionWizard, showCustomActionShare, setCustomActionBeingEdited },
} = customActionSlice;
